<template>
    <div class="map-container-height">
        <!--Will Not Toggle Properly if put into a class...Leave inline-->
        <div @dblclick="zoomIn" @contextmenu="zoomOut" style="width: 50vw; height: 100%;" id='routeDetailsMap'></div>
    </div>
</template>

<script>
    import mapboxgl from 'mapbox-gl';
    import {mapActions, mapGetters} from 'vuex'
    import mapHelpers from "../../utils/helpers/mapHelpers";
    export default {
        name: 'route-details-map-view',
        data: () => ({
            map: null,
            accessToken: 'pk.eyJ1IjoiaG9za2luc3QiLCJhIjoiY2s5M2N6NHprMDEwNDNkbWJieThzbm1hNiJ9.0F7I8B6DKLxTzAXg1oN9Hw',
            mapStyle: 'mapbox://styles/mapbox/outdoors-v12',
            coordinates: [-122.9110, 49.2057],
            routeId: 0,
            color: '',
            currentMarkers: [],
            clickCounter: 0
        }),
        mounted() {
            this.createMap();
        },
        methods: {
            ...mapActions({
                getRouteLocations: 'routes/getRouteAndLocations',
                getIsolateRouteLocations: 'routes/getIsolatedRoute',
                select: 'jobTasks/getById'
            }),
            createMap() {
                mapboxgl.accessToken = this.accessToken
                // init the map
                this.map = new mapboxgl.Map({
                    container: 'routeDetailsMap',
                    style: this.mapStyle,
                    center: this.coordinates,
                    zoom: 9,
                })
                this.map.on('load', () => {
                    this.map.resize();
                });
                this.map['doubleClickZoom'].disable()
                this.map.addControl(new mapboxgl.NavigationControl());
                this.map.addControl(
                    new mapboxgl.GeolocateControl({
                        positionOptions: {
                            enableHighAccuracy: true
                        },
                        showAccuracyCircle: false,
                        trackUserLocation: true
                    })
                );
                this.addMarkers()
            },
            async setRoutePins(route) {
                await this.getIsolateRouteLocations(route.id)
            },
            addMarkers() {
                let marker
                this.clearMarkers()
                this.routeCoordinates.forEach(taskLocation => {
                    if (!taskLocation) {
                        return
                    }
                    let popup = new mapboxgl.Popup({ closeOnClick: false, offset: 25 })
                        .setHTML(`<h5>${taskLocation.address}</h5>`)
                    const useSelectedIcon = (this.selected && (taskLocation.taskId === this.selected.id))
                    if(taskLocation.iconId == null || taskLocation.iconId === 0){
                       const markerType = mapHelpers.parseType(taskLocation)
                        marker = new mapboxgl.Marker({ element: (useSelectedIcon ? mapHelpers.getHighlightElement(markerType) : mapHelpers.getElement(markerType))})
                            .setLngLat(taskLocation.coordinates)
                            .setPopup(popup)
                            .addTo(this.map)
                    } else {
                        marker = new mapboxgl.Marker({ element: mapHelpers.getNumberIconElementForIconId(taskLocation.iconId, useSelectedIcon)})
                            .setLngLat(taskLocation.coordinates)
                            .setPopup(popup)
                            .addTo(this.map)
                    }

                    marker.getElement().addEventListener('click', () => {
                        taskLocation.id = taskLocation.taskId
                        this.$emit('selectTask', taskLocation)
                    });
                    this.currentMarkers.push(marker);
                })
            },

            clearMarkers() {
                if (this.currentMarkers.length !== 0) {
                    this.currentMarkers.forEach(marker => {
                        marker.remove()
                        marker = []
                    })
                }
            },
            zoomIn() {
                let z = this.map.getZoom()
                this.map.flyTo({ zoom: z + 2, speed: 0.2, curve: 1, essential: true })
            },
            zoomOut (e) {
                e.preventDefault()
                this.clickCounter++
                if (this.clickCounter === 2) {
                    let z = this.map.getZoom()
                    this.map.flyTo({ zoom: z - 2, speed: 0.2, curve: 1, essential: true })
                    this.clickCounter = 0
                }
            },
        },
        watch: {
            async routeCoordinates() {
                await this.addMarkers()
            },
            async clickCounter () {
                await mapHelpers.sleep(500).then(() => this.clickCounter = 0)
            },
            selected () {
                this.addMarkers()
            },
        },
        computed: {
            ...mapGetters({
                routeLocations: 'routes/routeLocations',
                selected: 'jobTasks/selectedJobTask'
            }),
            routeCoordinates () {
                if(!this.routeLocations){ //Avoid console null error when route has no tasks
                   return []
                }
                return this.routeLocations.map(route => {
                    if (route.status === 'Assigned' || route.status === 'InProgress' || route.status === 'Reassigned') {
                        route.coordinates = [route.longitude, route.latitude]
                        if (this.routeId !== route.id) {
                            this.color = route.color
                            this.routeId = route.id
                        }
                        return route
                    }
                })
            },
        }
    }
</script>
<style>
    .marker-order {
        width: 36px;
        height: 36px;
        cursor: pointer;
    }
    .select-marker-order {
        background-size: cover;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        cursor: pointer;
        background-color: #00A5C5;
    }
    .map-container-height{
        height: 100%;
    }
    .mapboxgl-ctrl-top-right .mapboxgl-ctrl {
        margin: 14px 12px 0 0 !important;
    }
    .mapboxgl-canvas {
        height: 100% !important;
    }
    .mapboxgl-marker:hover {
        cursor: pointer;
    }
    .order-icon-default {
        background-image: url('../../assets/numberIcons/numeric-0-circle.png');
    }
    .order-icon-1 {
        background-image: url('../../assets/numberIcons/numeric-1-circle.png');
    }
    .order-icon-2 {
        background-image: url('../../assets/numberIcons/numeric-2-circle.png');
    }
    .order-icon-3 {
        background-image: url('../../assets/numberIcons/numeric-3-circle.png');
    }
    .order-icon-4 {
        background-image: url('../../assets/numberIcons/numeric-4-circle.png');
    }
    .order-icon-5 {
        background-image: url('../../assets/numberIcons/numeric-5-circle.png');
    }
    .order-icon-6 {
        background-image: url('../../assets/numberIcons/numeric-6-circle.png');
    }
    .order-icon-7 {
        background-image: url('../../assets/numberIcons/numeric-7-circle.png');
    }
    .order-icon-8 {
        background-image: url('../../assets/numberIcons/numeric-8-circle.png');
    }
    .order-icon-9 {
        background-image: url('../../assets/numberIcons/numeric-9-circle.png');
    }
    .order-icon-10 {
        background-image: url('../../assets/numberIcons/numeric-10-circle.png');
    }
    .order-icon-11 {
        background-image: url('../../assets/numberIcons/numeric-11-circle.png');
    }
    .order-icon-12 {
        background-image: url('../../assets/numberIcons/numeric-12-circle.png');
    }
    .order-icon-13 {
        background-image: url('../../assets/numberIcons/numeric-13-circle.png');
    }
    .order-icon-14 {
        background-image: url('../../assets/numberIcons/numeric-14-circle.png');
    }
    .order-icon-15 {
        background-image: url('../../assets/numberIcons/numeric-15-circle.png');
    }
    .order-icon-16 {
        background-image: url('../../assets/numberIcons/numeric-16-circle.png');
    }
    .order-icon-17 {
        background-image: url('../../assets/numberIcons/numeric-17-circle.png');
    }
    .order-icon-18 {
        background-image: url('../../assets/numberIcons/numeric-18-circle.png');
    }
    .order-icon-19 {
        background-image: url('../../assets/numberIcons/numeric-19-circle.png');
    }
    .order-icon-20 {
        background-image: url('../../assets/numberIcons/numeric-20-circle.png');
    }
</style>
